import React, { useState } from "react";
import styles from "./ShareVideo.module.scss";
import { Tabs, Tab } from "@blueprintjs/core";
import CopyLinkTab from "./CopyLinkTab";
import EmbedTab from "./EmbedTab";
import SocialTab from "./SocialTab";

export default function ShareVideo({ videoId, videoUrl }) {
  const [selectedTabId, setSelectedTabId] = useState("copyLink");

  return (
    <div className={styles.shareVideo}>
      <Tabs
        selectedTabId={selectedTabId}
        onChange={(tabId) => setSelectedTabId(tabId)}
      >
        <Tab
          id="copyLink"
          title="Link"
          panel={<CopyLinkTab videoId={videoId} />}
        />
        <Tab
          id="social"
          title="Social"
          panel={
            <SocialTab
              videoId={videoId}
              onCopyLinkClick={() => setSelectedTabId("copyLink")}
            />
          }
        />
        <Tab
          id="embed"
          title="Embed"
          panel={<EmbedTab videoId={videoId} videoUrl={videoUrl} />}
        />
      </Tabs>
    </div>
  );
}
